import { useNavigate } from "react-router-dom";
import { useWorkStepImport } from "../../../../contexts/workStepImportContext";
import { WorkStepsUploadCard } from "./components/WorkStepsUploadCard";

export const UploadWorkStepsPage = () => {
  const navigate = useNavigate();
  const { clear } = useWorkStepImport();

  return (
    <div className="w-full p-10 max-w-[900px] mx-auto">
      <div className="mb-6">
        <div className="text-sm text-stone-500 mb-1">Bulk Import</div>
        <h1 className="text-3xl font-bold tracking-tight">Upload Work Steps</h1>
        <div className="text-stone-600 mt-1">
          Supports Excel (.xlsx, .xls) and CSV files — including AuditBoard work
          step exports
        </div>
      </div>

      <WorkStepsUploadCard
        onCancel={() => {
          clear();
          navigate("/audit/work-steps");
        }}
      />
    </div>
  );
};

export default UploadWorkStepsPage;
